import { Bar } from "react-chartjs-2";

import { ensureChartDefaults } from "./chartDefaults";
import { usePalette } from "./usePalette";
import type { DailyPoint } from "../../../api/types";

export interface DailyBarChartProps {
  points: DailyPoint[];
  label: string;
  color: string;
  unit: string;
}

export default function DailyBarChart({
  points,
  label,
  color,
  unit,
}: DailyBarChartProps) {
  const palette = usePalette();
  ensureChartDefaults(palette);

  const data = {
    labels: points.map((p) => p.day),
    datasets: [
      {
        label,
        data: points.map((p) => p.value),
        backgroundColor: color,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          callback: (value: string | number) =>
            `${(Number(value) || 0).toFixed(0)} ${unit}`,
        },
      },
    },
    plugins: { legend: { display: false } },
  } as const;

  return <Bar data={data} options={options} />;
}
